import styled from '@emotion/styled';

export const MarqueeRoot = styled.div<{ insetShadow: boolean }>`
  direction: ltr;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
  position: relative;
  width: 100%;
  -ms-overflow-style: none;  /* IE and Edge */
  box-shadow: ${({ insetShadow }) => insetShadow ? 'rgba(0, 0, 0, 0.1) 0px 2px 5px 0px inset;' : 'none'};
`;

export const MarqueeWrapper = styled.div`
  overflow: hidden;
  display: flex;
  position: relative;
  width: 100%;
  height: auto;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const MarqueeContent = styled.div<{ time: number; ltr: boolean }>`
  white-space: nowrap;
  will-change: transform;
  animation: ${({ ltr }) => ltr ? 'marquee-horizontal-reverse' : 'marquee-horizontal'} ${({ time  }) => time || 90}s linear infinite;
  animation-play-state: running;
  position: relative;
  display: flex;
  width: auto;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  flex: 0 0 auto;

  &:hover, &:focus {
    animation-play-state: paused;
  }

  @keyframes marquee-horizontal {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }
  @keyframes marquee-horizontal-reverse {
    from { transform: translateX(-50%); }
    to { transform: translateX(0); }
  }
`;
